import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Webinar } from '../../models/webinar/webinar.interface';

@Injectable({ providedIn: 'root' })
export class WebinarService {
	private readonly relativeUrl = 'webinars';
	constructor(private readonly http: HttpClient) {}

	getWebinars(): Observable<Array<Webinar>> {
		return this.http.get<Array<Webinar>>(`${this.relativeUrl}`);
	}
}
